import { Member, MemberAlias } from '@nextforce/api'

export function convertMemberAliasesToMembers(
  memberAlias: MemberAlias[]
): Member[] {
  return memberAlias.map(alias => {
    const member: Member = {
      id: alias.toString(),
      firstName: alias,
      isAlias: true,
    }
    return member
  })
}
